/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Alert } from '@mui/material';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/background.png";
import tflogo from "assets/img/thermo.svg";
import axios from "axios";
import { useToken } from "hooks/token.js"
import { useHistory } from "react-router-dom";

function Basic(props) {
  const tokenURI = '/api/v1/auth';
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [token, setToken] = useToken();
  let historyObj = useHistory();
  const [error, setError] = useState();


  const onKeyPress = (e) => {
    if(e.key === 'Enter') {
      handleSubmit();
    }
  };

  const onTabUserInput = (e) => {
    if(e.key === "Tab") {
      e.preventDefault();
      const passInput = document.getElementById('passwordInput');
      passInput.select();
    }
  }

  const handleSubmit = async() => {
    setError(null)
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    try {
      const tokenResponse = await axios.post(
        tokenURI,
        formData.toString(),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
          }
        },
      );
      if (tokenResponse.hasOwnProperty('data') && tokenResponse.data.hasOwnProperty('data')) {
        if(tokenResponse.data.data.is_password_default) {
          localStorage.setItem('pwd', password);
          localStorage.setItem('pwdToken', tokenResponse.data.data.token);
          historyObj.push("/pwd/changepassword");
        } else {
          setToken(tokenResponse.data.data.token)
          historyObj.push("/")
        }
      } else {
        throw new Error('api response missing data');
      }
      
    } catch(e) {
      if(!e.hasOwnProperty('response') || !e.response.hasOwnProperty('status')) {
        setError(e.message)
        return;
      }
      if (e.response.status == 401) {
        setError("The username, password, or both are incorrect.")
        return
      } else if (e.response.status == 400) {
        setError("Bad Request.")
        return
      } else {
        setError("Unknown error")
      }
    }
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          backgroundColor="#ECE8E7"
          borderRadius="lg"
          coloredShadow="dark"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          sx={{ background: "lightgrey" }}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={6}>
              <div >
                <img src={tflogo} alt="logo" />
              </div>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDBox sx={{ margin: "15px" }}>
                {error ? <Alert severity="error" >{error}</Alert> : ""}
              </MDBox>
              <MDInput
                type="text"
                name="user"
                label="User"
                id="userInput"
                onChange={e => setUserName(e.target.value)}
                onKeyPress={onKeyPress}
                onKeyDown={onTabUserInput}
                fullWidth
                />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                name="pass"
                label="Password"
                id="passwordInput"
                onChange={e => setPassword(e.target.value)}
                onKeyPress={onKeyPress}
                fullWidth
                />
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" onClick={handleSubmit} color="dark" fullWidth>
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
